// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","tooltip":"tooltip_tooltip__srgQg","help":"tooltip_help__KqPQb","tooltipText":"tooltip_tooltipText__ZsTHN","bottom":"tooltip_bottom__EcrX1"};